import { DomChangedDirective } from './_directives/dom-changed-directive.directive';
import { CrossAppMessagingService } from 'src/app/core/_services/crossApp-messaging.service';
import { FilterOrdersByStatusPipe } from './_pipes/filter-orders.pipe';
import { EventNamePipe } from './_pipes/event-name.pipe';
import { RouterModule } from '@angular/router';
import { GoogleSigninButtonDirectiveDirective } from './_directives/google-signin-button-directive.directive';
import { ToDeliveryTypeNamePipe } from './_pipes/ToDeliveryTypeName.pipe';
import { GroupBoxComponent } from './group-box/group-box.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { FullNamePipe } from './_pipes/full-name.pipe';
import { ToProductPipe } from './_pipes/ToProduct.pipe';
import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './login/login.component';
import { AppVersionCheckService } from './_services/app-version-check.service';
import { HttpBackend, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProductsInGroupPipe } from './_pipes/productsInGroup.pipe';
import { ToAllergenNamePipe } from './_pipes/ToAllergenName.pipe';
import { ToAllergenClassPipe } from './_pipes/ToAllergenClass.pipe';
import { AccessDeniedInterceptor } from './accessDeniedInterceptor';

import { TranslationComponent } from './translation/translation.component';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, LOCALE_ID, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NameTranslationEditComponent } from './name-translation-edit/name-translation-edit.component';
import { OrderStatusPipe } from './_pipes/orderStatus.pipe';
import { OrderStatusToneDirective } from './_directives/order-status-tone.directive';
import { EnumCheckboxSelectorComponent } from './enum-checkbox-selector/enum-checkbox-selector.component';

import { EnumEnumeratorPipe } from './_pipes/enumEnumerator.pipe';
import { HasPermissionPipe } from './_pipes/hasPermission.pipe';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { IsBusyDirective } from './_directives/is-busy.directive';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
// QRCodeScannerComponent je standalone i učitava se dinamički (WebQRCodeScanerService) —
// namerno NIJE importovan/deklarisan ovde da @zxing/library ne uđe u inicijalni bundle.


import { InViewDirective } from './_directives/inView.directive';
import { GetProductByIDPipe } from './_pipes/getProductByID.pipe';
import { ParentProductPipe } from './_pipes/parentProduct.pipe';
import { GroupOrderItemModifiersPipe } from './_pipes/groupOrderItemModifiers.pipe';
import { OrderItemDetailsComponent } from './order-item-details/order-item-details.component';
import { ToGroupIconClassPipe } from './_pipes/ToGroupIconClass.pipe';
import { ChildProductsPipe } from './_pipes/ChildProducts.pipe';
import { ToProductsPipe } from './_pipes/ToProducts.pipe';
import { SortPipe } from './_pipes/sort.pipe';
import { AuthTokenLoadedResolver } from './_helpers/auth-token-loaded-resolver';
import { RouteLoadingComponent } from './route-loading/route-loading.component';
import { SaveButtonComponent } from './save-button/save-button.component';
import { OrderStatusSelectorComponent } from './order-status-selector/order-status-selector.component';
import { TableGroupsPipe } from './_pipes/table-groups.pipe';
import { NoWebsocketConnectionComponent } from './no-websocket-connection/no-websocket-connection.component';
import { StickyThingDirective } from './_directives/sticky-thing.directive';
import { StatusAvailablePipe } from './_pipes/status-available.pipe';
import { TimeSincePipe } from './_pipes/time-since.pipe';
import { ReduceStringArrayPipe } from './_pipes/reduce-string-array.pipe';
import { SortOrdersByDatePipe } from './_pipes/sort-orders-by-date.pipe';
import { ToggleFullScreenComponent } from './toggle-full-screen/toggle-full-screen.component';
import { VirtualKeyboardComponent } from './virtual-keyboard/virtual-keyboard.component';
import { OrderDeliveryTypeIconComponent } from './order-delivery-type-icon/order-delivery-type-icon.component';
import { OrderDetailsDialogComponent } from './order-details-dialog/order-details-dialog.component';
import { DriverPickerDialogComponent } from './driver-picker-dialog/driver-picker-dialog.component';
import { VersionComponent } from './version/version.component';
import { DeviceInfoBarComponent } from './device-info-bar/device-info-bar.component';
import { ChargeComponent } from './charge/charge.component';
import { PaymentMethodNamePipe } from './_pipes/payment-method-name.pipe';
import { IsPaymentTypeEnabledPipe } from './_pipes/is-payment-type-enabled.pipe';

import { registerLocaleData } from '@angular/common';
import localeSr from '@angular/common/locales/sr';
import { HasAdminPermissionPipe } from './_pipes/hasAdminPermission.pipe';
import { ImageSizePipe } from './_pipes/imageSize.pipe';
import { WoltOrderDetailsComponent } from './wolt-order-details/wolt-order-details.component';
import { PropertyItemComponent } from './property-item/property-item.component';
import { WoltOrderStatusNamePipe } from './wolt-order-details/wolt-order-status-name.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SelectPreparationTimeComponent } from './select-preparation-time/select-preparation-time.component';
import { PreserveNewLinePipe } from './_pipes/preserve-new-line.pipe';
import { SelectRejectReasonComponent } from './select-reject-reason/select-reject-reason.component';
import { DialogTitleComponent } from './dialog-title/dialog-title.component';
import { ProviderIconComponent } from './provider-icon/provider-icon.component';

import { DragToScrollDirective } from './_directives/drag-to-scroll.directive';
import { OrderIconsComponent } from './order-icons/order-icons.component';
import { MrDOrderDetailsComponent } from './mr-dorder-details/mr-dorder-details.component';
import { CodeSigninComponent } from './code-signin/code-signin.component';
import { ConnectionStatusComponent } from './connection-status/connection-status.component';
import { SplitLettersDirective } from './code-signin/split-letters.directive';
import { OrderProgressBarComponent } from './order-progress-bar/order-progress-bar.component';
import { OrderProgressColorPipe } from './_pipes/order-progress-color.pipe';
import { ProgressBarColor } from './_directives/ProgressBarColor.directive';
import { SelectLanguagePipe } from './_pipes/select-language.pipe';
import { CapsWarningPipe } from './_pipes/caps-warning.pipe';
import { UserRatingComponent } from './user-rating/user-rating.component';
import { OrderStatusChangeLogComponent } from './order-status-change-log/order-status-change-log.component';
import { SelectOnFocusDirective } from './_directives/select-on-focus.directive';
import { PhoneNumberPipe } from './_pipes/phone-number.pipe';
import { CustomerEditComponent } from './customer-edit/customer-edit.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { TookanModule } from './tookan/tookan.module';
import { NumericalSortPipe } from './_pipes/numerical-sort.pipe';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { GetTableByIDPipe } from './_pipes/getTableByID.pipe';
import { ClickStopPropagationDirective } from './_directives/click-stop-propagation.directive';
import { ElapsedMinutesPipe } from './_pipes/elapsed-minutes.pipe';
import { OrderItemColorDirective } from './order-summary/order-item-color.directive';
import { ClientEditComponent } from './client-edit/client-edit.component';
import { SearchClientsComponent } from './search-clients/search-clients.component';
import { FieldPipe } from './_pipes/field.pipe';
import { DeviceIDInterceptor } from './deviceID.interceptor';
import { STORAGE_SERVICE } from './_interface/storage';
import { environment } from 'src/environments/environment';
import { isNativeShell } from './_helpers/native-shell';
import { StorageService } from './_services/storage.service';
import { CrossDomainStorageService } from './_services/cross-domain-storage.service';
import { PWANotificationProvider } from './_services/pwaNotificationProvider.service';
import { NOTIFICATION_PROVIDER } from './_interface/notificationProvider';
import { SwPush } from '@angular/service-worker';
import { BeepService } from './_services/beep.service';
import { NativeNotificationProvider } from './_services/nativeNotificationProvider';
import { ReplaceNewLinePipe } from './_pipes/replace-new-line.pipe';
import { WebQRCodeScanerService } from './_services/web-qrcode-scaner.service';
import { QRCODE_SCANER } from './_interface/IQRCodeScanner';
import { NativeQRCodeScanerService } from './_services/native-qrcode-scaner.service';
import { HasInvalidDetailsPipe } from './order-details/has-invalid-details.pipe';
import { DisableAnimationDirective } from './_directives/disableAnimation.directive';
import { PinLoginComponent } from './pin-login/pin-login.component';
import { LanguagePickerComponent } from './language-picker/language-picker.component';
import { SplitStringPipe } from './_pipes/SplitString.pipe';
import { CookieService } from 'ngx-cookie-service';

import { ConcurrentLimitMonitorService } from './_services/concurrentLimitMonitor.service';
import { ServiceMessageMonitorService } from './_services/serviceMessageMonitor.service';
import { GetUserFromIDPipe } from './_pipes/get-user-from-id.pipe';
import { ClientEditDialogComponent } from './client-edit-dialog/client-edit-dialog.component';
import { WebsocketConnectionListComponent } from './websocketConnectionList/websocketConnectionList.component';
import { DeviceEditComponent } from './device-edit/device-edit.component';
import { DeviceSettingsFormComponent } from './device-settings/device-settings-form/device-settings-form.component';
import { DeviceAppSettingsPanelComponent } from './device-settings/device-app-settings-panel/device-app-settings-panel.component';
import { DeviceLogListComponent } from './deviceLogList/deviceLogList.component';
import { DeviceActionsMenuComponent } from './device-actions-menu/device-actions-menu.component';
import { FilterWSConnectionByCompanyPipe } from './websocketConnectionList/filterWSconnectionByCompany.pipe';
import { FilterByApplicationNamePipe } from './websocketConnectionList/filterByApplicationName.pipe';
import { VarDirective } from './_directives/Var.directive';
import { FirstGroupNamePipe } from './_pipes/FirstGroupName.pipe';
import { LangChangeEvent, MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MyMissingTranslationHandler } from './missingTranslationHandler';
import { SortLanguagesPipe } from './_pipes/SortLanguages.pipe';
import { SelectDueDateComponent } from './selectDueDate/selectDueDate.component';
import { MaterialModule } from '../angularMaterial/material/material.module';
import { JsonParsePipe } from './_pipes/jsonParse.pipe';
import { EnumItemNamePipe } from './enum-checkbox-selector/EnumItemName.pipe';
import { IsInvalidOrderPipe } from './_pipes/isInvalidOrder.pipe';
import { AppVersionInterceptor } from './appVersion.interceptor';
import { LoadImagePipe } from './_pipes/loadImage.pipe';
import { SortByNamePipe } from './_pipes/sortByName.pipe';
import { OfflineDetectorInterceptor } from './offlineDetectorInterceptor';
import { InactivityMonitorComponent } from './InactivityMonitor/InactivityMonitor.component';
import { NativeLogger } from './_helpers/nativeLogger';
import { LoggerModule, NGXLogger, NgxLoggerLevel, TOKEN_LOGGER_WRITER_SERVICE } from 'ngx-logger';
import { DBLogger } from './_helpers/dbLogger';
import { SendLogService } from './_services/sendLog.service';
import { LogNavigationService } from './_services/logNavigation.service';
import { formatBrowserLabel, getBrowserInfo } from './_helpers/browser-info';
import { PleaseWaitComponent } from './please-wait/please-wait.component';
import { LayoutItemComponent } from './tableLayout/layoutItem/layoutItem.component';
import { MatContextMenuTriggerDirective } from './_directives/MatContextMenuTrigger.directive';
import { TableLayoutComponent } from './tableLayout/layout/layout.component';
import { TransformRotateDirective } from './tableLayout/TransformRotate.directive';
import { ResizeDirective } from './_directives/resize-directive';
import { POSNamePipe } from './_pipes/POSName.pipe';
import { LogRequestsInterceptor } from './logRequests.interceptor';
import { ErrorHandlerService } from './_services/ErrorHandler.service';
import { SearchCustomersComponent } from './search-customers/search-customers.component';
import { OrderItemStatusPipe } from './_pipes/orderItemStatus.pipe';
import { OrderStatusNamesPipe } from './_pipes/orderStatusNames.pipe';
import { AppLogoNameComponent } from './appLogoName/appLogoName.component';
import { IsYoutubeURLPipe } from './_pipes/IsYoutubeURL.pipe';
import { ExtractYoutubeVideoIDPipe } from './_pipes/extractYoutubeVideoID.pipe';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { BannerComponent } from './banner/banner.component';
import { DistinctCompaniesPipe } from './websocketConnectionList/distinctCompanies.pipe';
import { CompanyAdminSettingsComponent } from './companyAdminSettings/companyAdminSettings.component';
import { DoubleClickDetectDirective } from './_directives/DoubleClickDetect.directive';
import { ChargeAmountSelectorComponent } from './ChargeAmountSelector/ChargeAmountSelector.component';
import { NumericKeypadComponent } from './numeric-keypad/numeric-keypad.component';
import { NumericKeypadDialogComponent } from './numeric-keypad/numeric-keypad-dialog.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ToolbarDirective } from './_directives/toolbar.directive';
import { ItemChipListComponent } from './itemChipList/itemChipList.component';
import { ImageSelectorComponent } from './imageSelector/imageSelector.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips';
import { JwtInterceptor } from './jwtInterceptor';
import { SidePanelComponent } from './sidePanel/sidePanel.component';
import { HasDirtyFlagDirective, SidenavCloseGuardDirective } from './_directives/sidenavCloseGuard.directive';
import { SplitSidenavDirective } from './_directives/splitSidenav.directive';
import { QuantityComponent } from './quantity/quantity.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { LoadingComponent } from './loading/loading.component';
import { IsProductAvailablePipe } from './_pipes/is-product-available.pipe';
import { IsGroupAvailablePipe } from './_pipes/is-group-available.pipe';
import { EnterQRCodeComponent } from './enterQRCode/enterQRCode.component';
import { GroupCharactersPipe } from './_pipes/groupCharacters.pipe';
import { ToTableNamePipe } from './_pipes/toTableName.pipe';
import { ContainsItemPipe } from './_pipes/containsItem.pipe';
import { InfoTooltip } from './infoTooltip/infoTooltip';
import { SystemNotificationsComponent } from './system-notifications/system-notifications.component';
import { SystemToastsComponent } from './system-notifications/system-toasts.component';
import { SettingSelectComponent } from './setting-select/setting-select.component';
import { SettingToggleComponent } from './setting-toggle/setting-toggle.component';
import { SettingStepperComponent } from './setting-stepper/setting-stepper.component';
import { SignageComponent } from './signage/signage.component';
import { NativeTransactionsComponent } from './nativeTransactions/nativeTransactions.component';
import { VersionPickerComponent } from './version-picker/version-picker.component';
// HandlebarsLiveEditorComponent i PrintTemplateDialogComponent su standalone i učitavaju se
// dinamički (app otvara dijalog kroz import()) — namerno NISU deklarisani ovde, da `handlebars`
// ne uđe u bundle app-ova koji šablone štampe ne koriste. Isti razlog kao za QRCodeScanner.

registerLocaleData(localeSr);

// configureEnvironment() was the legacy way to populate environment.apiBase/backendBase/host from
// the current hostname (e.g. "admin-s01.test.emeni.rs" → "app-s01.test.emeni.rs"). That logic has
// been folded into `deriveBackendOrigin()` (src/environments/derive-origin.ts) and exposed through
// getters on the environment object — so the values always reflect window.location without a
// one-time module-init mutation. Old call kept commented as a breadcrumb; the function itself is
// left as a no-op for any external callers.
// configureEnvironment(environment);

export function httpCoreTranslationLoaderFactory(handler: HttpBackend) {

  const http = new HttpClient(handler); // ✅ bypasses ALL interceptors

  //  console.log("httpTranslationLoaderFactory");
  return new TranslateHttpLoader(
    http,
    `./assets/i18n/core/`,
    '.json'
  );
}

function installGlobalLogHooks(logger: NGXLogger) {
  return () => {
    // Promise greške van Angular zone ne prolaze kroz ErrorHandler — bez ovoga ih u logu nema.
    window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
      logger.error('Unhandled promise rejection', e.reason);
    });

    // Prelazi online/offline — najčešći terenski problem; daje kontekst WS reconnect logovima.
    window.addEventListener('online', () => logger.info('Browser reports: online'));
    window.addEventListener('offline', () => logger.warn('Browser reports: offline'));

    // Tab/WebView u pozadini (tajmeri i WS su throttled) — objašnjava "rupe" u logu.
    document.addEventListener('visibilitychange', () => {
      logger.debug('Document visibility: ' + document.visibilityState);
    });

    // Razlikovanje urednog gašenja (reload/navigacija) od pada aplikacije; upis je best-effort.
    window.addEventListener('pagehide', () => logger.info('Page unloading'));

    if (!environment.production) {
      // U dev-u konzola ostaje netaknuta (writeToConsole već preslikava log u konzolu).
      return;
    }

    // console.warn/error (uključujući tuđe biblioteke) → centralni log, samo u produkciji.
    // Rest-parametri: ranije se hvatao SAMO prvi argument, pa je npr.
    // console.error("failed", err) gubio sam Error objekat.
    window.console.warn = (...args: any[]) => {
      logger.warn("console", ...args);
    };

    window.console.error = (...args: any[]) => {
      logger.error("console", ...args);
    };
  };
}

@NgModule({ declarations: [
        TranslationComponent,
        NameTranslationEditComponent,
        OrderStatusPipe,
        OrderStatusToneDirective,
        OrderItemStatusPipe,
        EnumCheckboxSelectorComponent,
        EnumEnumeratorPipe,
        HasPermissionPipe,
        AlertDialogComponent,
        IsBusyDirective,
        InvoiceDetailsComponent,
        ToAllergenClassPipe,
        ToAllergenNamePipe,
        InViewDirective,
        GetProductByIDPipe,
        ParentProductPipe,
        GroupOrderItemModifiersPipe,
        OrderItemDetailsComponent,
        ProductsInGroupPipe,
        ToGroupIconClassPipe,
        ChildProductsPipe,
        ToProductsPipe,
        SortPipe,
        LoginComponent,
        LogoutComponent,
        RouteLoadingComponent,
        SaveButtonComponent,
        OrderStatusSelectorComponent,
        TableGroupsPipe,
        NoWebsocketConnectionComponent,
        StickyThingDirective,
        StatusAvailablePipe,
        ToProductPipe,
        TimeSincePipe,
        ReduceStringArrayPipe,
        SortOrdersByDatePipe,
        ToggleFullScreenComponent,
        VirtualKeyboardComponent,
        FullNamePipe,
        OrderDetailsComponent,
        GroupBoxComponent,
        ToDeliveryTypeNamePipe,
        OrderDeliveryTypeIconComponent,
        OrderDetailsDialogComponent,
        DriverPickerDialogComponent,
        VersionComponent,
        DeviceInfoBarComponent,
        ChargeComponent,
        PaymentMethodNamePipe,
        GoogleSigninButtonDirectiveDirective,
        IsPaymentTypeEnabledPipe,
        HasAdminPermissionPipe,
        ImageSizePipe,
        EventNamePipe,
        WoltOrderDetailsComponent,
        PropertyItemComponent,
        WoltOrderStatusNamePipe,
        SelectPreparationTimeComponent,
        PreserveNewLinePipe,
        SelectRejectReasonComponent,
        DialogTitleComponent,
        ProviderIconComponent,
        DragToScrollDirective,
        OrderIconsComponent,
        MrDOrderDetailsComponent,
        CodeSigninComponent,
        ConnectionStatusComponent,
        SplitLettersDirective,
        OrderProgressBarComponent,
        OrderProgressColorPipe,
        ProgressBarColor,
        FilterOrdersByStatusPipe,
        SelectLanguagePipe,
        CapsWarningPipe,
        UserRatingComponent,
        OrderStatusChangeLogComponent,
        SelectOnFocusDirective,
        PhoneNumberPipe,
        CustomerEditComponent,
        CustomerDetailsComponent,
        NumericalSortPipe,
        OrderSummaryComponent,
        GetTableByIDPipe,
        ClickStopPropagationDirective,
        ElapsedMinutesPipe,
        OrderItemColorDirective,
        SearchClientsComponent,
        ClientEditComponent,
        FieldPipe,
        ReplaceNewLinePipe,
        HasInvalidDetailsPipe,
        DisableAnimationDirective,
        DomChangedDirective,
        PinLoginComponent,
        LanguagePickerComponent,
        SplitStringPipe,
        GetUserFromIDPipe,
        ClientEditDialogComponent,
        WebsocketConnectionListComponent,
        DeviceEditComponent,
        DeviceSettingsFormComponent,
        DeviceAppSettingsPanelComponent,
        DeviceLogListComponent,
        DeviceActionsMenuComponent,
        FilterWSConnectionByCompanyPipe,
        FilterByApplicationNamePipe,
        VarDirective,
        FirstGroupNamePipe,
        SortLanguagesPipe,
        SelectDueDateComponent,
        JsonParsePipe,
        EnumItemNamePipe,
        IsInvalidOrderPipe,
        LoadImagePipe,
        SortByNamePipe,
        InactivityMonitorComponent,
        PleaseWaitComponent,
        TableLayoutComponent,
        LayoutItemComponent,
        MatContextMenuTriggerDirective,
        TransformRotateDirective,
        ResizeDirective,
        POSNamePipe,
        SearchCustomersComponent,
        OrderStatusNamesPipe,
        AppLogoNameComponent,
        BannerComponent,
        SignageComponent,
        IsYoutubeURLPipe,
        ExtractYoutubeVideoIDPipe,
        DistinctCompaniesPipe,
        CompanyAdminSettingsComponent,
        DoubleClickDetectDirective,
        ChargeAmountSelectorComponent,
        NumericKeypadComponent,
        NumericKeypadDialogComponent,
        ToolbarComponent,
        ToolbarDirective,
        ItemChipListComponent,
        ImageSelectorComponent,
        SidePanelComponent,
        SidenavCloseGuardDirective,
        SplitSidenavDirective,
        HasDirtyFlagDirective,
        QuantityComponent,
        SearchBoxComponent,
        LoadingComponent,
        IsProductAvailablePipe,
        IsGroupAvailablePipe,
        EnterQRCodeComponent,
        GroupCharactersPipe,
        ToTableNamePipe,
        ContainsItemPipe,
        InfoTooltip,
        SystemNotificationsComponent,
        // internal — SystemStatusService creates it on <body> itself; deliberately not exported
        SystemToastsComponent,
        SettingSelectComponent,
        SettingToggleComponent,
        SettingStepperComponent,
        NativeTransactionsComponent,
        VersionPickerComponent
    ],
    exports: [
        TranslationComponent,
        NameTranslationEditComponent,
        OrderStatusPipe,
        OrderStatusToneDirective,
        OrderItemStatusPipe,
        EnumCheckboxSelectorComponent,
        EnumEnumeratorPipe,
        HasPermissionPipe,
        AlertDialogComponent,
        IsBusyDirective,
        ToAllergenClassPipe,
        ToAllergenNamePipe,
        InViewDirective,
        GetProductByIDPipe,
        ParentProductPipe,
        GroupOrderItemModifiersPipe,
        OrderItemDetailsComponent,
        ProductsInGroupPipe,
        ToGroupIconClassPipe,
        ChildProductsPipe,
        ToProductsPipe,
        SortPipe,
        LoginComponent,
        LogoutComponent,
        RouteLoadingComponent,
        SaveButtonComponent,
        OrderStatusSelectorComponent,
        TableGroupsPipe,
        NoWebsocketConnectionComponent,
        StickyThingDirective,
        StatusAvailablePipe,
        ToProductPipe,
        TimeSincePipe,
        ReduceStringArrayPipe,
        SortOrdersByDatePipe,
        ToggleFullScreenComponent,
        FullNamePipe,
        OrderDetailsComponent,
        GroupBoxComponent,
        ToDeliveryTypeNamePipe,
        OrderDeliveryTypeIconComponent,
        OrderDetailsDialogComponent,
        DriverPickerDialogComponent,
        VersionComponent,
        DeviceInfoBarComponent,
        ChargeComponent,
        PaymentMethodNamePipe,
        HasAdminPermissionPipe,
        ImageSizePipe,
        EventNamePipe,
        DialogTitleComponent,
        ProviderIconComponent,
        DragToScrollDirective,
        OrderIconsComponent,
        OrderProgressBarComponent,
        FilterOrdersByStatusPipe,
        SelectLanguagePipe,
        CapsWarningPipe,
        SelectOnFocusDirective,
        UserRatingComponent,
        PropertyItemComponent,
        PhoneNumberPipe,
        CustomerEditComponent,
        CustomerDetailsComponent,
        TookanModule,
        NumericalSortPipe,
        OrderSummaryComponent,
        GetTableByIDPipe,
        ReplaceNewLinePipe,
        FieldPipe,
        DisableAnimationDirective,
        DomChangedDirective,
        PinLoginComponent,
        ConnectionStatusComponent,
        LanguagePickerComponent,
        SplitStringPipe,
        GetUserFromIDPipe,
        ClientEditComponent,
        WebsocketConnectionListComponent,
        DeviceEditComponent,
        DeviceSettingsFormComponent,
        DeviceAppSettingsPanelComponent,
        DeviceLogListComponent,
        DeviceActionsMenuComponent,
        VarDirective,
        FirstGroupNamePipe,
        JsonParsePipe,
        TranslateModule,
        IsInvalidOrderPipe,
        LoadImagePipe,
        SortByNamePipe,
        InactivityMonitorComponent,
        PleaseWaitComponent,
        TableLayoutComponent,
        LayoutItemComponent,
        POSNamePipe,
        SearchCustomersComponent,
        OrderStatusNamesPipe,
        AppLogoNameComponent,
        SortLanguagesPipe,
        FilterByApplicationNamePipe,
        BannerComponent,
        CompanyAdminSettingsComponent,
        DoubleClickDetectDirective,
        ToolbarComponent,
        ToolbarDirective,
        ItemChipListComponent,
        ImageSelectorComponent,
        SidePanelComponent,
        SidenavCloseGuardDirective,
        SplitSidenavDirective,
        HasDirtyFlagDirective,
        QuantityComponent,
        NumericKeypadComponent,
        SearchBoxComponent,
        LoadingComponent,
        IsProductAvailablePipe,
        IsGroupAvailablePipe,
        EnterQRCodeComponent,
        ToTableNamePipe,
        ContainsItemPipe,
        InfoTooltip,
        SystemNotificationsComponent,
        SettingSelectComponent,
        SettingToggleComponent,
        SettingStepperComponent,
        SignageComponent,
        NativeTransactionsComponent,
        VersionPickerComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
        NgxDropzoneModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        DragDropModule,
        MatChipsModule,
        TookanModule,
        YouTubePlayerModule,
        TranslateModule.forChild({
            /*
            loader: {
              provide: TranslateLoader,
              useFactory: httpCoreTranslationLoaderFactory,
              deps: [HttpBackend]
            },
            */
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MyMissingTranslationHandler
            },
            isolate: false,
            extend: true
        }),
        LoggerModule.forRoot({
            // TRACE u razvoju; u produkciji DEBUG — TRACE spam (HTTP "request started"/"SENT"
            // linije i sl.) na sporim uređajima primetno usporava hladan start jer svaka
            // linija ide kroz writer (native bridge / IndexedDB). Za terensku dijagnostiku
            // nivo se može vratiti na TRACE kroz localStorage 'eMeniLogLevel' (vidi CoreModule).
            level: environment.production ? NgxLoggerLevel.DEBUG : NgxLoggerLevel.TRACE,
            disableFileDetails: true,
        }, {
            writerProvider: {
                provide: TOKEN_LOGGER_WRITER_SERVICE,
                useFactory: createLogger,
                deps: [Injector, CrossAppMessagingService]
            }
        })], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AccessDeniedInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: OfflineDetectorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DeviceIDInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AppVersionInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LogRequestsInterceptor, multi: true },
        AuthTokenLoadedResolver,
        { provide: LOCALE_ID, useValue: 'sr' },
        { provide: STORAGE_SERVICE, useFactory: createStorageService, deps: [Injector] },
        { provide: NOTIFICATION_PROVIDER, useFactory: createNotificationProvider, deps: [Injector] },
        { provide: QRCODE_SCANER, useFactory: createQRCodeScaner, deps: [Injector] },
        CookieService,
        {
            provide: APP_INITIALIZER, useFactory: () => () => { }, deps: [SendLogService,
                ConcurrentLimitMonitorService,
                ServiceMessageMonitorService,
                AppVersionCheckService,
                // instanciranje ovde uključuje log navigacije u SVIM aplikacijama (ranije samo kiosk)
                LogNavigationService],
            multi: true
        },
        {
            provide: APP_INITIALIZER, useFactory: installGlobalLogHooks, deps: [NGXLogger],
            multi: true
        },
        { provide: ErrorHandler, useClass: ErrorHandlerService, deps: [NGXLogger] },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {
  constructor(private injector: Injector,
    log: NGXLogger,
    private translationService: TranslateService) {
    globalThis.AppInjector = this.injector;

    // Override nivoa logovanja za terensku dijagnostiku, npr:
    //   localStorage.setItem('eMeniLogLevel', 'TRACE')  (TRACE|DEBUG|INFO|WARN|ERROR)
    try {
      const overrideLevel = localStorage.getItem('eMeniLogLevel');
      if (overrideLevel && (NgxLoggerLevel as any)[overrideLevel] !== undefined) {
        log.updateConfig({ ...log.getConfigSnapshot(), level: (NgxLoggerLevel as any)[overrideLevel] });
      }
    } catch { /* localStorage nedostupan — ostaje podrazumevani nivo */ }

    // Jedna INFO linija sa kontekstom uređaja — prvo što treba pri čitanju tuđeg loga
    // (verzija, browser/Chromium baza, rezolucija, jezik, mreža).
    let startupInfo = "Starting app " + environment.appVersion;
    try {
      const browser = getBrowserInfo();
      startupInfo += " | " + (formatBrowserLabel(browser) || browser.userAgent || "unknown browser")
        + " | viewport " + window.innerWidth + "x" + window.innerHeight + " @" + window.devicePixelRatio
        + " | lang " + navigator.language
        + " | " + (navigator.onLine ? "online" : "offline");
    } catch { /* dijagnostika je best-effort */ }
    log.info(startupInfo);

    // Zauzeće browser storage-a (IndexedDB log, keš menija...) — dijagnoza "puna memorija" uređaja.
    try {
      navigator.storage?.estimate?.().then(est => {
        const mb = (n?: number) => n == null ? "?" : (n / 1024 / 1024).toFixed(1) + "MB";
        log.debug("Storage usage " + mb(est.usage) + " of " + mb(est.quota));
      }).catch(() => { });
    } catch { /* starije WebView baze nemaju storage.estimate */ }

  /*  this.translationService.store.onLangChange.subscribe(
      (lang: LangChangeEvent) => {
        //  if (!environment.production) {
        //   console.log(' ==> LazyLoadedModule CORE ', lang);
        //  }
        this.translationService.use(lang.lang);
      }
    );*/
  }
}

function createStorageService(injector: Injector) {
  // CrossDomainStorageService exists to share auth state between sibling apps on different
  // subdomains (konobar.emeni.rs ↔ app.emeni.rs) via a hidden iframe + postMessage. When the
  // app runs same-origin with the backend — e.g. the LocalServer path-prefix setup, or any
  // same-origin production — there is nothing to bridge, so we fall back to plain localStorage.
  // Native wrappers stay on StorageService unchanged (no DOM iframe available).
  const isNative = isNativeShell();
  const sameOrigin =
    typeof window !== 'undefined' &&
    (!environment.backendBase || environment.backendBase === window.location.origin);

  if (isNative || sameOrigin) {
    return new StorageService();
  }
  return new CrossDomainStorageService();
}



function createLogger(injector: Injector, crossAppMessaging: CrossAppMessagingService) {
  if (isNativeShell()) {
    return new NativeLogger(crossAppMessaging);
  } else {
    return new DBLogger();
  }
}


function createNotificationProvider(injector: Injector) {
  if (isNativeShell()) {
    var s = inject(CrossAppMessagingService)
    return new NativeNotificationProvider(s);
  } else {
    var swPush = inject(SwPush);
    var beep = inject(BeepService);

    return new PWANotificationProvider(swPush, beep);
  }
}

function createQRCodeScaner(injector: Injector) {
  if (isNativeShell()) {
    var s = inject(CrossAppMessagingService)
    var translate = inject(TranslateService)
    return new NativeQRCodeScanerService(s, translate);

  } else {

    return new WebQRCodeScanerService(injector);
  }
}



/**
 * @deprecated Retained as a no-op for backward compatibility. The old implementation mutated
 * `environment.apiBase / backendBase / host` from the current hostname — that logic now lives in
 * `deriveBackendOrigin()` (src/environments/derive-origin.ts) and is exposed via getters on the
 * environment object, so values are always in sync with `window.location` without a module-init
 * side effect. Also, after the environment getters were introduced, this function would crash
 * with "Cannot set property apiBase of [object Object] which has only a getter".
 *
 * Callers can safely remove invocations of this function. Kept here to avoid breaking any code
 * outside this module that still imports the name.
 */
export function configureEnvironment(_env: any): void {
  // intentionally empty
}
